import { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { TNodeFormValues, TNodeRequestHumanReview, type TDelayState } from '../../node.type'
import { DOCUMENT_DEFAULT_DELAY } from './dashboard-toggle.helper'
import { useChatbotFlow } from '../../chatbot.provider'
import { formatCombinedIsoDuration, parseCombinedIsoDuration } from 'src/utils/duration-iso.util'

export function useNodeRequestHumanReview() {
  const { control, setValue } = useFormContext<TNodeFormValues>()
  const { updateCurrentNodeData } = useChatbotFlow()

  const humanReviewCheck = useWatch({ control, name: 'humanReviewCheck' })

  const delayState = useMemo<TDelayState>(() => {
    if (humanReviewCheck?.delay) {
      try {
        const parsed = parseCombinedIsoDuration(humanReviewCheck.delay)
        return { days: parsed.days, hours: parsed.hours, minutes: parsed.minutes }
      } catch {
        return DOCUMENT_DEFAULT_DELAY
      }
    }
    return DOCUMENT_DEFAULT_DELAY
  }, [humanReviewCheck?.delay])

  const writeNodeValue = () => {
    const newValue: TNodeRequestHumanReview = {
      delay: humanReviewCheck?.delay ?? formatCombinedIsoDuration(DOCUMENT_DEFAULT_DELAY),
    }
    setValue('humanReviewCheck', newValue)
    updateCurrentNodeData({ humanReviewCheck: newValue })
  }

  const clearNodeValue = () => {
    setValue('humanReviewCheck', undefined)
    updateCurrentNodeData({ humanReviewCheck: undefined })
  }

  const writeDelay = (newDelay: TDelayState) => {
    const newValue: TNodeRequestHumanReview = { delay: formatCombinedIsoDuration(newDelay) }
    setValue('humanReviewCheck', newValue)
    updateCurrentNodeData({ humanReviewCheck: newValue })
  }

  return {
    humanReviewCheck,
    delayState,
    writeNodeValue,
    clearNodeValue,
    writeDelay,
  }
}
